import { createSlice } from "@reduxjs/toolkit";

const initialFields = {
  stakeholderForm: {},
  contactForm: true,
  contactFormFields: {},
  clusterFormFields: {},
  financeFormFields: {},
  operationFormFields: {},
  configurationFormFields: {},
  stakeholderTypes: [],
  consignmentTypeFormFields: {},
};

const stakeholderSlice = createSlice({
  name: "stakeholder",
  initialState: initialFields,
  reducers: {
    setMandatoryFields: (state, action) => {
      return { ...state, stakeholderForm: action.payload };
    },
    setContactForm: (state, action) => {
      return { ...state, contactForm: action.payload };
    },
    setContactFormFields: (state, action) => {
      return { ...state, contactFormFields: action.payload };
    },
    setClusterFormFields: (state, action) => {
      return { ...state, clusterFormFields: action.payload };
    },
    setFinanceFormFields: (state, action) => {
      return { ...state, financeFormFields: action.payload };
    },
    setOperationFormFields: (state, action) => {
      return { ...state, operationFormFields: action.payload };
    },
    setConfigurationFormFields: (state, action) => {
      return { ...state, configurationFormFields: action.payload };
    },
    setStakeholderTypes: (state, action) => {
      return { ...state, stakeholderTypes: action.payload };
    },
    setConsignmentTypeFormFields: (state, action) => {
      return { ...state, financeFormFields: action.payload };
    },
  },
});

export const stakeholderActions = stakeholderSlice.actions;
export default stakeholderSlice;
